interface Props {
  onSelect: (value: string) => void;
}

export const IssueSelection: React.FC<Props> = ({ onSelect }) => {
  const issues = [
    {
      label: 'Received all products, but there are issues.',
      description: 'e.g., damaged, rotten, incorrect products',
      value: '',
    },
    {
      label: 'Did not receive some or all products.',
      description: 'e.g., missing products, incorrect quantity',
      value: 'missing_products',
    },
  ];

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium">
        What issue are you experiencing with your order?
      </h2>
      {issues.map(issue => (
        <div
          key={issue.value}
          onClick={() => {
            onSelect(issue.value);
          }}
          className="cursor-pointer border rounded-lg p-4 flex justify-between items-center hover:shadow"
        >
          <div>
            <div className="font-medium">{issue.label}</div>
            <div className="text-gray-500 text-sm">{issue.description}</div>
          </div>
          <div className="text-green-600">&gt;</div>
        </div>
      ))}
    </div>
  );
};
